import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Panel from '../../components/common/Panel';
import BackTop from '../../components/common/BackTop';
import PageLayout from '../../components/common/PageLayout';
import ActivationHeader from '../../components/blocks/ActivationHeader';
import ActivationPaymentContainer from '../blocks/ActivationPaymentContainer';
import ActivationServicesContainer from '../blocks/ActivationServicesContainer';
import IntegrationModal from '../../components/modals/IntegrationModal';
import { getActivationSupplier } from '../../store/actions/activation';
import Spinner from '../../components/common/Spinner';

function ActivationPageContainer(props) {
  const { getSupplierData, supplierId, supplier, isLoading } = props;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    getSupplierData(supplierId);
  }, [getSupplierData, supplierId]);

  const hasPublishableKey = supplier && !!supplier.supplier.stripe_publishable_key;

  const panel = (
    <Panel>
      <BackTop text={props.retailerName} />
    </Panel>
  );

  return (
    <PageLayout top={panel}>
      {isLoading || !supplier ? (
        <Spinner />
      ) : (
        <>
          <IntegrationModal open={open} onClose={() => setOpen(false)} />

          <ActivationHeader open={() => setOpen(true)} supplierData={supplier} />

          <ActivationServicesContainer supplierData={supplier} />

          {hasPublishableKey && <ActivationPaymentContainer supplierData={supplier} />}
        </>
      )}
    </PageLayout>
  );
}

const mapStateToProps = (state, ownProps) => {
  const { activation, role } = state;
  const {
    match: { params },
  } = ownProps;
  const supplierId = +params.supplierId;

  return {
    supplierId,
    retailerName: role.retailer.name,
    supplier: activation.supplier,
    isLoading: activation.isLoading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getSupplierData: (id) => dispatch(getActivationSupplier(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivationPageContainer);

ActivationPageContainer.defaultProps = {
  supplier: undefined,
};

ActivationPageContainer.propTypes = {
  retailerName: PropTypes.string,
  supplier: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  getSupplierData: PropTypes.func.isRequired,
};
